/*
 * Popup blur-overlay failsafe.
 *
 * Some iPhones fail to fire the CSS "animationend" event that popup.js
 * relies on to remove the "popup-open" class when a popup closes. When
 * that happens, the associated .popup-overlay (which uses
 * backdrop-filter: blur(4px)) never gets hidden, leaving the whole page
 * looking permanently blurred on mobile.
 *
 * This script does NOT change how popups open or close. It only adds a
 * safety-net timeout that guarantees the same cleanup popup.js already
 * performs (removing "popup-open" / "popup-scroll-hidden") happens even
 * if the animationend event never fires. If the normal cleanup already
 * ran, these calls are harmless no-ops.
 */
(function () {
	var CLEAR_DELAY = 1200; // ms - comfortably longer than any popup exit animation

	function forceClearPopups() {
		document.querySelectorAll(".popup.popup-open").forEach(function (popup) {
			popup.classList.remove("popup-open");
			popup.classList.add("popup-already-opened");
		});
		document.body.classList.remove("popup-scroll-hidden");
	}

	// Safety net for normal close actions (close button, accept button,
	// age-verification close, clicking the overlay).
	document.addEventListener(
		"click",
		function (event) {
			var target = event.target;
			if (
				target.closest(".popup-close") ||
				target.closest(".popup-accept") ||
				target.closest(".age-verification__popup-close") ||
				target.closest(".popup-overlay")
			) {
				setTimeout(forceClearPopups, CLEAR_DELAY);
			}
		},
		true
	);

	// Safety net for iOS back/forward-cache restores, which can leave
	// stale popup state applied to the restored page.
	window.addEventListener("pageshow", function (event) {
		if (event.persisted) {
			forceClearPopups();
		}
	});
})();